import { faSquare } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'

import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons'
import classNames from 'classnames'
import './styles.css'

type Props = {
  value: string
  text: string
  isChecked: boolean
  onClick: (value: string) => void
}

export class CheckboxOption extends Component<Props> {
  render = () => (
    <div
      className={classNames('checkbox-option mb-1-5', {
        'checkbox-option-checked': this.props.isChecked,
      })}
      onClick={this.props.onClick.bind(this, this.props.value)}
    >
      <FontAwesomeIcon
        className="checkbox-option-icon mr-1-5"
        icon={this.props.isChecked ? faCheckSquare : faSquare}
      />
      <span className="text-large checkbox-option-text">{this.props.text}</span>
    </div>
  )
}
